import { createGlobalStyle } from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { colorBrandYamahaRed, colorCoreBlack900Base, colorCoreWhite1000, colorCoreGray500, colorBlackTransparent300, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationTopLvl4 } from '@yme/tokens/elevations';
import { ADAPTIVE } from '@yme/tokens/screen';
import { transition300ms } from '@yme/tokens/transitions';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
export const OneTrustStyles = createGlobalStyle `
  // styles for OneTrust Cookie Banner
  #onetrust-banner-sdk {
    box-shadow: ${elevationTopLvl4};
    transition: ${transition300ms}; 
  }

  #onetrust-consent-sdk #onetrust-banner-sdk *:focus {
    outline: none !important;
  }

  #onetrust-banner-sdk div.ot-sdk-container {
    width: 100%;
    padding: 24px 16px;
  }

  #onetrust-banner-sdk div#onetrust-policy {
    margin: 0;
  }

  #onetrust-consent-sdk h2#onetrust-policy-title {
    margin-bottom: 0;
    text-transform: uppercase;
    color: ${colorCoreBlack900Base};

    ${getTextStyles('Play', 700, 18, 24)}
  }

  #onetrust-consent-sdk div#onetrust-policy-text {
    margin-top: 8px;

    ${getTextStyles('Ubuntu', 400, 16, 24)}
  }

  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-policy-text a {
    margin-left: 0;
    font-weight: initial;
  }

  #onetrust-banner-sdk .ot-sdk-container div#onetrust-button-group-parent {
    position: static;
    width: 100%;
    margin-left: 0;
    margin-top: 24px;
    transform: initial;
  }

  #onetrust-banner-sdk .has-reject-all-button div#onetrust-button-group {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  #onetrust-consent-sdk button#onetrust-accept-btn-handler,
  #onetrust-banner-sdk button#onetrust-reject-all-handler,
  #onetrust-consent-sdk button#onetrust-pc-btn-handler {
    height: 48px;
    width: 100%;
    padding: 12px 24px;
    margin: 0;
    border-radius: 24px;
    text-transform: uppercase;

    ${getTextStyles('Ubuntu', 500, 14, 20)}
  }

  #onetrust-consent-sdk button#onetrust-accept-btn-handler {
    &:hover,
    &:focus {
      background-color: ${colorBrandYamahaRed};
      border-color: ${colorBrandYamahaRed};
      opacity: 1;
    }
  }

  #onetrust-banner-sdk button#onetrust-reject-all-handler,
  #onetrust-consent-sdk button#onetrust-pc-btn-handler {
    &:hover,
    &:focus {
      background-color: ${colorCoreBlack900Base};
      border-color: ${colorCoreBlack900Base};
      color: ${colorCoreWhite1000};
      opacity: 1;
    }
  }

  #onetrust-banner-sdk button#onetrust-reject-all-handler {
    background-color: transparent;
    color: ${colorCoreBlack900Base};
  }

  #onetrust-consent-sdk #onetrust-banner-sdk:focus {
    outline: none;
  }

  #onetrust-banner-sdk .ot-sdk-eight.ot-sdk-columns {
    width: 100% !important;
  }

  #onetrust-banner-sdk #onetrust-button-group-parent {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  #onetrust-consent-sdk #onetrust-banner-sdk p {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  #onetrust-consent-sdk #onetrust-banner-sdk ul {
    margin-top: 16px;
    margin-bottom: 16px;
    padding-left: 40px;
    list-style: disc;
  }

  #onetrust-consent-sdk #onetrust-banner-sdk li {
    margin-bottom: 0;
  }

  // style for truncated-text
  #onetrust-banner-sdk {
    .truncated-text {
      display: -webkit-box;
      -webkit-line-clamp: 9;
      -webkit-box-orient: vertical;
      overflow: hidden;
      margin-bottom: 16px;
    }

    .truncated-text__checkbox {
      display: none !important;
    }

    .truncated-text__show-more-label,
    .truncated-text__show-less-label {
      display: initial;
      cursor: pointer;
      color: ${colorCoreBlack900Base} !important;

      ${getTextStyles('Ubuntu', 500, 16, 24)}

      &:hover {
        text-decoration: underline;
      }
    }

    .truncated-text__show-less-label {
      display: none;
    }

    .truncated-text__checkbox:checked ~ .truncated-text {
      display: initial;
      overflow: visible;
    }

    .truncated-text__checkbox:checked ~ .truncated-text__show-more-label {
      display: none;
    }

    .truncated-text__checkbox:checked ~ .truncated-text__show-less-label {
      display: initial;
    }
  }

  ${ADAPTIVE.minWidth.tablet} {
    #onetrust-banner-sdk div.ot-sdk-container {
      padding: 32px 24px;
    }

    #onetrust-banner-sdk .truncated-text {
      -webkit-line-clamp: 5;
    }
  }

  ${ADAPTIVE.minWidth.desktop} {
    #onetrust-banner-sdk div.ot-sdk-container {
      padding: 48px;
    }

    #onetrust-banner-sdk div.ot-sdk-row {
      display: flex;
      justify-content: space-between;
    }

    #onetrust-banner-sdk .ot-sdk-container div#onetrust-button-group-parent {
      position: static !important;
      width: auto;
      flex-shrink: 0;
      margin-top: auto;
      margin-bottom: 0;
    }

    #onetrust-banner-sdk.ot-buttons-fw:not(.ot-iab-2) #onetrust-button-group button {
      margin: 0 !important;
    }

    #onetrust-banner-sdk .ot-sdk-eight.ot-sdk-columns {
      margin-right: 48px;
    }

    #onetrust-consent-sdk h2#onetrust-policy-title {
      ${getTextStyles(null, null, 24, 28)}
    }

    #onetrust-banner-sdk .truncated-text {
      -webkit-line-clamp: 4;
    }
  }

  // styles for OneTrust Preference Center
  #onetrust-consent-sdk #onetrust-pc-sdk *:focus {
    outline: none !important;
  }

  #onetrust-pc-sdk div.ot-pc-header {
    padding-left: 0;
  }

  #onetrust-consent-sdk #onetrust-pc-sdk #ot-pc-title {
    ${getTextStyles('Play', 700, 18, 24)}
  }

  #onetrust-consent-sdk #onetrust-pc-sdk #ot-pc-desc {
    margin-bottom: 24px;

    ${getTextStyles('Ubuntu', 400, 16, 24)}
  }

  #onetrust-consent-sdk #onetrust-pc-sdk button#accept-recommended-btn-handler,
  #onetrust-pc-sdk.ot-ftr-stacked .ot-pc-footer button {
    height: 48px;
    padding: 12px 24px;
    margin: 0;
    border-radius: 24px;
    text-transform: uppercase;

    &:hover,
    &:focus {
      background-color: ${colorBrandYamahaRed} !important;
      border-color: ${colorBrandYamahaRed} !important;
      opacity: 1 !important;
    }

    ${getTextStyles('Ubuntu', 500, 14, 20)}
  }

  #onetrust-pc-sdk h3#ot-category-title {
    margin-bottom: 8px;
    padding: 0;

    ${getTextStyles('Play', 700, 18, 24)}
  }

  #onetrust-pc-sdk .ot-accordion-layout.ot-cat-item {
    border-left: none !important;
    border-right: none !important;
    border-radius: ${CORNER_RADIUS.none} !important;

    ${getTextStyles('Ubuntu', 500, 16, 24)}
  }

  #onetrust-pc-sdk .ot-cat-item>button {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  #onetrust-pc-sdk .ot-vs-config .ot-acc-hdr .ot-always-active {
    font-weight: 400;
    color: ${colorBrandYamahaRed};
  }

  #onetrust-pc-sdk .ot-arw-cntr {
    margin-right: 0;
  }

  #onetrust-pc-sdk .ot-arw-cntr .ot-arw {
    width: 24px !important;
    height: 24px !important;
    color: ${colorCoreBlack900Base} !important;
  }

  #onetrust-consent-sdk #onetrust-pc-sdk p {
    ${getTextStyles('Ubuntu', 400, 16, 24)}
  }

  #onetrust-pc-sdk .ot-switch-nob {
    background-color: ${colorCoreGray500} !important;
  }

  #onetrust-pc-sdk .ot-tgl input:checked+.ot-switch .ot-switch-nob {
    background-color: ${colorCoreBlack900Base} !important;
  }

  #onetrust-consent-sdk #onetrust-pc-sdk .ot-tgl input:focus + .ot-switch {
    outline: none !important;
  }

  #onetrust-pc-sdk.ot-ftr-stacked .ot-btn-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 16px !important;
    margin-bottom: 16px !important;
  }

  #onetrust-pc-sdk .ot-pc-footer {
    max-height: 176px !important;
    z-index: ${Z_INDEX.level2};
    background-color: ${colorCoreWhite1000};
  }

  #onetrust-consent-sdk #onetrust-pc-sdk .ot-btn-container button {
    height: 48px;
    padding: 12px 24px;
    border-radius: 24px;
    text-transform: uppercase;

    ${getTextStyles('Ubuntu', 500, 14, 20)}
  }

  #onetrust-consent-sdk #onetrust-pc-sdk .ot-btn-container button.save-preference-btn-handler {
    &:hover,
    &:focus {
      background-color: ${colorBrandYamahaRed} !important;
      border-color: ${colorBrandYamahaRed} !important;
      opacity: 1 !important;
    }
  }

  #onetrust-consent-sdk #onetrust-pc-sdk .ot-btn-container button.ot-pc-refuse-all-handler {
    color: ${colorCoreBlack900Base} !important;
    background-color: ${colorCoreWhite1000} !important;

    &:hover,
    &:focus {
      color: ${colorCoreWhite1000} !important;
      background-color: ${colorCoreBlack900Base} !important;
      border-color: ${colorCoreBlack900Base} !important;
      opacity: 1 !important;
    }
  }


  #ot-sdk-btn-floating .ot-floating-button__front {
    background-size: 60% !important;
    background-color: ${colorCoreWhite1000} !important;
    border: 1px solid ${colorCoreGray500};
  }

  #ot-sdk-btn-floating .ot-floating-button__back {
    background-color: ${colorCoreBlack900Base} !important;
  }

  #onetrust-pc-sdk .ot-pc-footer-logo {
    display: none;
  }

  #onetrust-pc-sdk #ot-pc-content.ot-pc-scrollbar {
    ${CustomScroll};

    max-height: none;
    padding-right: 4px;
  }

  #onetrust-pc-sdk #ot-pc-content.ot-pc-scrollbar::-webkit-scrollbar {
    width: 6px !important;
  }

  #onetrust-pc-sdk #ot-pc-content.ot-pc-scrollbar::-webkit-scrollbar-thumb {
    background-color: ${colorBlackTransparent300} !important;
    border-radius: 3px;
  }

  ${ADAPTIVE.minWidth.tablet} {
    #onetrust-pc-sdk .ot-pc-logo {
      display: none !important;
    }

    #onetrust-pc-sdk #ot-pc-content.ot-pc-scrollbar {
      padding-right: 16px;
    }
  }

  ${ADAPTIVE.minWidth.desktop} {
    #onetrust-consent-sdk #onetrust-pc-sdk #ot-pc-title {
      ${getTextStyles(null, null, 24, 28)}
    }
  }
`;
